<template>
    <div class="hidden gap-4 border-b border-gray-300 py-6 text-[16px] lg:flex">
        <div class="w-48 flex-none text-gray-800">{{ detailTitle }}</div>
        <div class="flex-grow text-gray-600">
            {{ detailDescription }}
        </div>
        <div class="w-32 flex-none">
            <span
                class="inline-block whitespace-nowrap rounded bg-gray-125 p-2 px-3 text-gray-625"
            >
                {{ pointsEarned }}/{{ pointsAvailable }} points
            </span>
        </div>
        <div
            v-if="!$slots.default"
            class="flex w-20 flex-none items-center justify-center"
        >
            <div v-if="completed">
                <svg
                    width="34"
                    height="34"
                    viewBox="0 0 34 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="17" cy="17" r="17" fill="#1F9294" />
                    <g clip-path="url(#clip0_1325_26467)">
                        <path
                            d="M15.4696 21.9836C15.1892 22.0587 14.887 21.9728 14.7147 21.739C14.3338 21.2233 14.0534 20.6405 13.8881 20.0211C13.5788 18.8666 13.6897 17.7 14.1258 16.6809C14.1915 16.5276 14.3173 16.4112 14.4515 16.313C14.7312 16.1087 14.9477 15.8166 15.0877 15.4892C15.4247 14.6987 15.923 13.9872 16.5508 13.4003C16.9599 13.0192 17.2724 12.531 17.3381 11.9767C17.3845 11.5883 17.3563 11.1947 17.255 10.8168L17.1431 10.3993C17.1079 10.268 17.1263 10.1282 17.1943 10.0106C17.2622 9.89294 17.3741 9.8071 17.5053 9.77194C17.8989 9.66646 18.3184 9.72168 18.6713 9.92545C19.0242 10.1292 19.2818 10.4648 19.3873 10.8585C19.5909 11.6185 19.6122 12.3841 19.4791 13.1091C19.4023 13.5243 19.7763 13.9359 20.184 13.8267L22.2462 13.2741C22.923 13.0928 23.6519 13.3882 23.9043 14.0424C24.0086 14.3129 24.0994 14.5911 24.1763 14.8781C24.6627 16.6825 24.5151 18.5991 23.7582 20.3078C23.5874 20.6943 23.236 20.9631 22.8283 21.0724L20.179 21.7823C19.8604 21.8676 19.5293 21.9012 19.1996 21.8821L16.9616 21.7464C16.6319 21.7269 16.3012 21.7606 15.9822 21.8462L15.4696 21.9836ZM10.6904 17.7683C10.5744 18.7897 10.6522 19.8239 10.9196 20.8165C11.1288 21.6006 11.4533 22.3493 11.8825 23.0381C12.2043 23.5528 12.8394 23.7489 13.4259 23.5917L14.0242 23.4314C14.3178 23.3528 14.4111 22.9756 14.2105 22.7466C13.5895 22.0384 13.1404 21.1965 12.898 20.2864C12.5961 19.1596 12.6278 18.022 12.9321 16.9782C13.0225 16.669 12.7441 16.3505 12.4328 16.4339L11.7394 16.6197C11.1906 16.7668 10.7554 17.2036 10.6904 17.7683Z"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_1325_26467">
                            <rect
                                width="16.3908"
                                height="16.3908"
                                fill="white"
                                transform="translate(7.21191 10.9395) rotate(-15)"
                            />
                        </clipPath>
                    </defs>
                </svg>
            </div>
        </div>
        <div
            v-else
            class="flex w-20 flex-none items-center justify-center hover:cursor-pointer"
            @click="toggleDetails"
        >
            <div v-if="detailsExpanded">
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g opacity="0.7">
                        <path
                            d="M6 15L12 9L18 15"
                            stroke="#777777"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </g>
                </svg>
            </div>
            <div v-else>
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    transform="rotate(180)"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g opacity="0.7">
                        <path
                            d="M6 15L12 9L18 15"
                            stroke="#777777"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </g>
                </svg>
            </div>
        </div>
    </div>
    <div
        class="flex w-full flex-col gap-2 border-b border-gray-300 py-4 text-[16px] lg:hidden"
    >
        <div class="flex w-full justify-between gap-4">
            <div class="text-gray-800">{{ detailTitle }}</div>
            <div class="">
                <span
                    class="m-4 whitespace-nowrap rounded bg-gray-125 p-2 text-gray-625"
                    >{{ pointsEarned }}/{{ pointsAvailable }} points</span
                >
            </div>
        </div>
        <div class="flex w-full items-start justify-between gap-4">
            <div class="text-gray-600">{{ detailDescription }}</div>
            <div
                v-if="$slots.default"
                class="flex flex-none items-center justify-center p-4 hover:cursor-pointer"
                @click="toggleDetails"
            >
                <div v-if="detailsExpanded">
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        transform="rotate(180)"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g opacity="0.7">
                            <path
                                d="M6 15L12 9L18 15"
                                stroke="#777777"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </g>
                    </svg>
                </div>
                <div v-else>
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g opacity="0.7">
                            <path
                                d="M6 15L12 9L18 15"
                                stroke="#777777"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </g>
                    </svg>
                </div>
            </div>
        </div>
    </div>
    <div
        v-if="$slots.default && detailsExpanded"
        class="border-b border-gray-300 pb-4"
    >
        <div class="bg-gray-100 p-4 text-[16px] text-gray-700">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "StudentReadinessScoreDetailRow",
    props: {
        detailTitle: {
            type: String,
            default: "",
        },
        detailDescription: {
            type: String,
            default: "",
        },
        pointsEarned: {
            type: Number,
            default: 0,
        },
        pointsAvailable: {
            type: Number,
            default: 0,
        },
        completed: {
            type: Boolean,
            default: false,
        },
        startOpen: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            detailsExpanded: this.startOpen,
        };
    },
    methods: {
        toggleDetails() {
            this.detailsExpanded = !this.detailsExpanded;
        },
    },
};
</script>
